import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaClipboardList, FaSignOutAlt, FaAddressBook  } from 'react-icons/fa';

const NavBarUser = () => {
  const { user, logout } = useAuth();

  console.log(user)

  if (!user) {
    return null;
  }

  return (
    <nav
      style={{
        backgroundColor: '#333',
        height: '100%',
        width: '65px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px 0',
        boxShadow: '2px 0 5px rgba(0, 0, 0, 0.1)',
        gap: '30px', // Espaciado entre los íconos aumentado
      }}
    >
      <ul style={{ listStyle: 'none', padding: 0, margin: 0, width: '100%' }}>
              {user.tipoRol === 'solicitar_reservas' && (
                <>
                  <li style={{ marginBottom: '30px', textAlign: 'center' }}> {/* Espaciado adicional */}
                    <Link to="/reservas" style={{ color: 'white', textDecoration: 'none' }}>
                      <FaClipboardList title="Reservas" style={{ fontSize: '30px' }} />
                    </Link>
                  </li>
                  <li style={{ marginBottom: '30px', textAlign: 'center' }}> {/* Espaciado adicional */}
                    <Link to="/reservas_usuario" style={{ color: 'white', textDecoration: 'none' }}>
                      <FaAddressBook title="Mis Reservas" style={{ fontSize: '30px' }} />
                    </Link>
                  </li>
                </>
              )}
              <li style={{ marginTop: 'auto', textAlign: 'center' }}>
                <button
                  onClick={logout}
                  style={{
                    background: 'transparent',
                    color: 'white',
                    border: 'none',
                  }}
                  title="Logout"
                >
                  <FaSignOutAlt style={{ fontSize: '30px' }} />
                </button>
              </li>
            </ul>
          </nav>
        );
      };

export default NavBarUser;
